<template>
  <v-row v-if="showBanner">
    <v-card
      id="business_account_banner"
      align="stretch"
      width="100%"
      class="pt-6 pl-6 pr-6 pb-6 mb-3 ba-banner"
      flat
    >
      <v-row class="px-0 py-0" align="center">
        <v-col cols="12" class="d-flex align-center">
          <v-card-text class="mt-0 pt-0 flex-grow-1">
            {{ banner.explainer }}
          </v-card-text>

          <v-btn
            class="mx-4 ba-banner__cta"
            depressed
            @click="$router.push(banner.btnPath)"
          >
            {{ banner.btnText }}
          </v-btn>

          <v-btn
            class="ml-2"
            icon
            aria-label="Close banner"
            @click="skipBanner"
          >
            <v-icon>
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-card>
  </v-row>
</template>

<script>
import businessAccount from '../../services/api/businessAccount'

export default {
  data() {
    return {
      banner: {
        explainer: this.$t('dashboard.banners.businessAccount.explainer'),
        btnPath: '/user/profile',
        btnText: this.$t('dashboard.banners.businessAccount.btnText')
      },
      showBanner: false
    }
  },
  async mounted() {
    await this.checkBannerVisibility()
  },
  methods: {
    async checkBannerVisibility() {
      const bannerSkipped = this.$cookies.get('ba-banner-skipped')
      if (bannerSkipped) {
        this.showBanner = false
        return
      }

      try {
        const businessAccountData = await businessAccount.getMyBusinessAccount()
        if (businessAccountData?.content && businessAccountData.content.length > 0 && businessAccountData.content[0].id) {
          this.showBanner = false
        } else {
          this.showBanner = true
        }
      } catch (error) {
        this.showBanner = true
      }
    },
    skipBanner() {
      this.$cookies.set('ba-banner-skipped', true, 60 * 60 * 24 * 365)
      this.showBanner = false
    }
  }
}
</script>
